import type { Dayjs } from "dayjs";

import type { IDataPoint } from "app/pages/digital-marketing/keywords-campaigns/reports/keywords-report/keywords-table/KeywordsReportTypes";
import type {
    ILanguageLocaleAndDescription,
    IRankTrackerColumn,
} from "app/pages/digital-marketing/keywords-campaigns/reports/shared/Table/TableUtils/RankTrackerTablesTypes";

import type { AntColumnType } from "../keywords-report/keywords-table/keywordsReportTableContext";

export interface TrendReportTableButtonsProps {
    excelURL: string;
    onColumnsChanged: (columns: IRankTrackerColumn[]) => void;
    columns: AntColumnType[];
    getSelectedIndex: () => number;
}

export type TargetUrlColumnData = {
    key: string;
    value: {
        dailyTopUrl: string;
        hitTargetUrl: boolean;
    };
};

export interface ITrend {
    key: string;
    value: number;
}

export interface ITrendFormatted {
    key: string;
    value: number | string;
}

interface ITrendTableDataBase {
    scrapingConfigurationId: string;
    volume: number;
    trend: ITrend[];
    searchEngine: string;
    keyword: string;
    targetUrls: string[];
    targetUrlOverTime: TargetUrlColumnData[];
}

export interface ITrendOriginalTableData extends ITrendTableDataBase {
    geoLocation: string;
    tags: string[];
}

export interface ITrendReportTableRecord extends ITrendTableDataBase {
    tags: {
        text: string;
    }[];
    geoLocation: ILanguageLocaleAndDescription;
    positionTrend: IDataPoint[];
    serpLinkDate?: Dayjs;
}

export interface ITrendReportTableManipulatedData {
    records: ITrendReportTableRecord[];
    totalCount: number;
    originalData: ITrendOriginalTableData[];
}
export interface ITrendReportTableOriginalResponse {
    records: ITrendOriginalTableData[];
    totalCount: number;
}

export enum ETrendReportTablwTabs {
    POSITIONS,
    TARGET_URLS,
    SERP_FEATURES,
}

export const TrendReportTableViewModes = {
    positions: "positions",
    targetUrl: "targetUrl",
    serpFeatures: "serpFeatures",
} as const;

export type ViewModeType = keyof typeof TrendReportTableViewModes;

export type TrendReportTableViewModesConfigs = {
    title: string;
    id: ViewModeType;
};
export type ReportSerpOnSite = {
    serpList: Record<string, boolean>;
};
